import { Box, Typography } from "@mui/material";

export default function Notifications() {
  return (
    <Box p={3}>
      <Typography variant="h4">Notifications</Typography>
    </Box>
  );
}